import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

@Component({
  selector: 'xemex-table-pagination',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.compact]': 'compact()' },
  templateUrl: './table-pagination.component.html',
  styleUrl: './table-pagination.component.scss',
})
export class TablePaginationComponent {
  page         = input.required<number>();
  totalPages   = input.required<number>();
  total        = input.required<number>();
  pageSize     = input.required<number>();
  showControls = input<boolean>(true);
  compact      = input<boolean>(false);

  pageChange = output<number>();

  protected start = computed(() =>
    this.total() === 0 ? 0 : (this.page() - 1) * this.pageSize() + 1,
  );
  protected end = computed(() => Math.min(this.page() * this.pageSize(), this.total()));
  protected pages = computed((): (number | '...')[] => {
    const total = this.totalPages();
    const current = this.page();

    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const rangeStart = Math.max(2, current - 2);
    const rangeEnd   = Math.min(total - 1, current + 2);
    const items: (number | '...')[] = [1];

    if (rangeStart > 2) items.push('...');
    for (let i = rangeStart; i <= rangeEnd; i++) items.push(i);
    if (rangeEnd < total - 1) items.push('...');

    items.push(total);
    return items;
  });

  go(n: number): void {
    const clamped = Math.max(1, Math.min(n, this.totalPages()));
    if (clamped !== this.page()) this.pageChange.emit(clamped);
  }
}
